module.exports = __webpack_public_path__ + "img/videosdk-item-3.74b467a.png";